import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { ErrorComponent } from '../shared/error/error.component';


const cRoutes: Routes = [

    {
      path: '',
      component: AdminComponent,
      children: [
          {
            path: 'users',
            loadChildren: 'app/admin/user/user.module#UserModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'schedules',
            loadChildren: 'app/admin/schedule/schedule.module#ScheduleModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'listado',
            loadChildren: 'app/admin/list-agent/list-agent.module#ListAgentModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'listado-espera',
            loadChildren: 'app/admin/list-wait/list-wait.module#ListWaitModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'report',
            loadChildren: 'app/admin/report/report.module#ReportModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'monitor',
            loadChildren: 'app/admin/monitor-agents/monitor-agents.module#MonitorAgentModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'statistics',
            loadChildren: 'app/admin/statistics/statistics.module#StatisticsModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'incident-control',
            loadChildren: 'app/admin/incident-control/incident-control.module#IncidentControlModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'emergency-times',
            loadChildren: 'app/admin/emergency-times/emergency-times.module#EmergencyTimesModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'agent-report',
            loadChildren: 'app/admin/agent-report/agent-report.module#AgentReportModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'wait-report',
            loadChildren: 'app/admin/wait-report/wait-report.module#WaitReportModule',
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'panel-control',
            loadChildren: 'app/admin/panel-control/panel-control.module#PanelControlModule',
            runGuardsAndResolvers: 'always',
          },
          {
            path: 'status',
            loadChildren: 'app/admin/status/status.module#StatusModule',
            runGuardsAndResolvers: 'always',
          },
          {
            path: 'tags',
            loadChildren: 'app/admin/tags/tags.module#TagsModule',
            runGuardsAndResolvers: 'always',
          },
          {
            path: 'templates',
            loadChildren: 'app/admin/templates/templates.module#TemplatesModule',
            runGuardsAndResolvers: 'always',
          },
          {
            path: 'users_pending',
            loadChildren: 'app/admin/users-pending/users-pending.module#UsersPendingModule',
            runGuardsAndResolvers: 'always',
          },
          {
            path: 'rooms-archived',
            loadChildren: 'app/admin/rooms-archived/rooms-archived.module#RoomsArchivedModule',
            runGuardsAndResolvers: 'always',
          },
          {
            path: 'segments',
            loadChildren: 'app/admin/segments/segments.module#SegmentsModule',
            runGuardsAndResolvers: 'always',
          },
          {
            path: 'status-agents',
            loadChildren: 'app/admin/status-agents/status-agents.module#StatusAgentsModule',
            runGuardsAndResolvers: 'always',
          },
          {
            path: 'video-call',
            loadChildren: 'app/admin/video-call/video-call.module#VideoCallModule',
            runGuardsAndResolvers: 'always',
          },
          
          {
            path: ''
          },
          {
            path: '**',
            component: ErrorComponent
          }
      ]
    }

];


@NgModule({
  imports: [
    RouterModule.forChild(
      cRoutes
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AdminRoutingModule {}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/admin-routing.module.ts